import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, from, switchMap} from 'rxjs';
import {environment} from '../../environments/environment';

export interface ShippingAddressPayload {
  fullName: string;
  line1: string;
  line2?: string;
  city: string;
  region?: string;
  postalCode: string;
  country: string;
  phone?: string;
  saveAsDefault?: boolean;
}

export interface OrderView {
  orderId: string;
  itemId: string;
  itemTitle: string;
  status: string;
  amountCents: number;
  currency: string;
  fulfillmentMode: string;
  supplierCode?: string;
  shipsInDays?: number;
  supplierSku?: string;
  supplierName?: string;
  supplierPoId?: string;
  fulfillmentStatus?: string;
  showSupplierFields?: boolean;
  buyerName?: string;
  buyerUrl?: string;
  buyerAvatarUrl?: string;
  sellerName?: string;
  sellerUrl?: string;
  sellerAvatarUrl?: string;
  shipFullName?: string;
  shipLine1?: string;
  shipLine2?: string;
  shipCity?: string;
  shipPostalCode?: string;
  shipCountry?: string;
  shipPhone?: string;
  trackingNumber?: string;
  trackingCarrier?: string;
  trackingUrl?: string;
  fulfilledOn?: string;
  createdOn?: string;
  paidOn?: string;
  payoutStatus?: string;
}

@Injectable({providedIn: 'root'})
export class OrderService {
  constructor(private http: HttpClient) {}

  createOrder(itemId: string, shipping: ShippingAddressPayload | null): Observable<OrderView> {
    return from(environment).pipe(
      switchMap((env: any) =>
        this.http.post<OrderView>(`${env.backendURL}/api/orders`, {
          itemId,
          shipping
        })
      )
    );
  }

  getOrder(orderId: string): Observable<OrderView> {
    return from(environment).pipe(
      switchMap((env: any) => this.http.get<OrderView>(`${env.backendURL}/api/orders/${orderId}`))
    );
  }

  listMine(role: 'buyer' | 'seller' = 'buyer'): Observable<OrderView[]> {
    return from(environment).pipe(
      switchMap((env: any) =>
        this.http.get<OrderView[]>(`${env.backendURL}/api/orders/mine`, {params: {role}})
      )
    );
  }
}
